export const GET_QC_DATA_START = "GET_QC_DATA_START";
export const GET_QC_DATA_SUCCESS = "GET_QC_DATA_SUCCESS";
export const GET_QC_DATA_FAIL = "GET_QC_DATA_FAIL";

export const SUBMIT_QC_START = "SUBMIT_QC_START";
export const SUBMIT_QC_SUCCESS = "SUBMIT_QC_SUCCESS";
export const SUBMIT_QC_FAIL = "SUBMIT_QC_FAIL";

export const RESET_FORM_DATA = "RESET_FORM_DATA";

export const SET_SELECTED_PAYMENT_DETAILS = "SET_SELECTED_PAYMENT_DETAILS";

export const SEARCH_PPSR_START = "SEARCH_PPSR_START";
export const SEARCH_PPSR_SUCCESS = "SEARCH_PPSR_SUCCESS";
export const SEARCH_PPSR_FAIL = "SEARCH_PPSR_FAIL";

export const GENERATE_PPSR_START = "GENERATE_PPSR_START";
export const GENERATE_PPSR_SUCCESS = "GENERATE_PPSR_SUCCESS";
export const GENERATE_PPSR_FAIL = "GENERATE_PPSR_FAIL";

export const CHECK_PPSR_STATUS_START = "CHECK_PPSR_STATUS_START";
export const CHECK_PPSR_STATUS_SUCCESS = "CHECK_PPSR_STATUS_SUCCESS";
export const CHECK_PPSR_STATUS_FAIL = "CHECK_PPSR_STATUS_FAIL";

export const RESET_PPSR_STATUS_CHECK = "RESET_PPSR_STATUS_CHECK";
